'use strict';

module.exports = {
  template: require('./contact-import.html'),
  controller: require('./contact-import.controller.js'),
  controllerAs: 'vm'
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/contact-import/index.js
 ** module id = 145
 ** module chunks = 0
 **/